module.exports = __webpack_public_path__ + "8288eac2319c69f86142182052a6b9b8.ttf";